<div [kgrLoading]="loading$ | async">
  @if (done) {
    <div>done</div>
  }
  @if (!done) {
    <div>
      <kgr-errors [errors]="errors"></kgr-errors>
      <kgr-errors [errors]="additionalErrorMessages"></kgr-errors>
      <form (submit)="onSubmit()" [formGroup]="form">
        <div class="kgr-inputGroup">
          <div class="kgr-grid kgr-grid--gutters kgr-grid--small-full kgr-grid--medium-fit">
            <div class="kgr-grid__cell">
              <kgr-form-field
                label="Passwort"
                i18n-label
                [errors]="(validationErrors$ | async).password"
                [showErrorsIfPristine]="showErrorsIfPristine$ | async"
                [showErrorsIfDirty]="true"
              >
                <kgr-password-input-control formControlName="password" autocomplete="new-password"></kgr-password-input-control>
                <div class="kgr-inputGroup__text kgr-row kgr-row--inverse kgr-row--smallMargin">
                  <ng-container *kgrIfInstitutionType="'club'" i18n>
                    Bitte verwende aus Sicherheitsgründen ein Passwort, das aus mind. 8 Zeichen und wenigstens einer Zahl (0-9) und einem
                    Sonderzeichen (z.B. !§$%&/+-#?) besteht.
                  </ng-container>
                  <ng-container *kgrIfInstitutionType="'kindergarten'" i18n>
                    Bitte verwenden Sie aus Sicherheitsgründen ein Passwort, das aus mind. 8 Zeichen und wenigstens einer Zahl (0-9) und
                    einem Sonderzeichen (z.B. !§$%&/+-#?) besteht.
                  </ng-container>
                </div>
              </kgr-form-field>
            </div>
            <div class="kgr-grid__cell">
              <kgr-form-field
                label="Passwort-Wiederholung"
                i18n-label
                [errors]="(validationErrors$ | async).passwordRepeated"
                [showErrorsIfPristine]="showErrorsIfPristine$ | async"
                [showErrorsIfDirty]="true"
              >
                <kgr-password-input-control formControlName="passwordRepeated" autocomplete="new-password"></kgr-password-input-control>
              </kgr-form-field>
            </div>
          </div>
        </div>
        <div class="kgr-inputGroup">
          <button type="submit" class="kgr-button kgr-button--accent" i18n="@@saveButtonLabel">Speichern</button>
        </div>
      </form>
    </div>
  }
</div>
